import { SERVICE_MASTER_STATUS, TOwnerAutoSuggestService } from "@elixir/types";
import { ManageServicesTableRowItemUi } from "ui";
import { manageServicesTableBodyConfig } from ".";
import usePutUpdateServicesMaster from "../../apis/axon/services/use-put-update-services-master";

const ManageServicesTableRowItem = ({
  query,
  serviceItem,
  isLastItem,
  onServiceEditClick,
  clinic_id,
  status,
  searchInAllServiceTypes,
}: {
  query: string;
  clinic_id: string;
  serviceItem: TOwnerAutoSuggestService;
  isLastItem: boolean;
  onServiceEditClick: (serviceItem: TOwnerAutoSuggestService) => void;
  status: SERVICE_MASTER_STATUS;
  searchInAllServiceTypes: boolean;
}) => {
  const { mutateAsync: putUpdateService } = usePutUpdateServicesMaster({
    query,
    clinic_id,
    status,
    searchInAllServiceTypes,
  });

  const handleServiceSwitchClick = async () => {
    await putUpdateService({
      price: serviceItem.price,
      service_name: serviceItem.service_name,
      service_id: Number(serviceItem.service_id),
      clinic_id,
      body: {
        archive: !serviceItem.archive,
        clinic_id,
      },
    });
  };
  const handleServiceEditClick = () => {
    onServiceEditClick(serviceItem);
  };

  return (
    <ManageServicesTableRowItemUi
      rowConfig={manageServicesTableBodyConfig}
      serviceItem={serviceItem}
      isLastItem={isLastItem}
      onEditClick={handleServiceEditClick}
      onSwitchClick={handleServiceSwitchClick}
    />
  );
};

export default ManageServicesTableRowItem;
